import helpers from '@lib/analytics/amplitude/helpers'
import date from '@lib/date'

const { sendEvent, sendEventWithTime, sendEventWithTimeAndConnection, getRouteParams, getPriceParams } = helpers

const viewPage = (): void => {
  sendEvent('view-landing-page', { express: true }, { measurePerformance: 'page' })
}

export interface ExpressTripProps {
  departureDate: string
  connection: Landing.Connection
  tripType: Landing.TripType
  price: Money | null
}

const clickTrip = (props: ExpressTripProps): void => {
  const { departureDate, connection, tripType, price } = props
  const eventParams = {
    ...getRouteParams(connection.departureLocation, connection.arrivalLocation),
    ...(price && getPriceParams(price)),
    departureDate: date.formatDate(date.parse(departureDate)),
    isReturn: tripType === 'two_way',
  }
  sendEvent('click-express-trip', eventParams)
}

const viewLandingCityPage = (): void => {
  sendEventWithTime('view-city-name')
}

const clickTripExtended = (connection: Connection, payload: any): void => {
  const fare = connection.fares.find(fare => fare.fareClass.code === payload.fareClass)

  const eventPayload = {
    fareClass: payload.fareClass,
    fareFeatures: fare?.fareClass.fareFeatures.map(fare => fare.code),
    departureDateTime: date.parse(connection.departureTime),
    duration: connection.duration,
    position: payload.position,
    addPrice: true,
  }

  sendEventWithTimeAndConnection('click-trip', eventPayload, { measurePerformance: 'page' }, connection)
}

const loadSearchResults = (
  connection: Connection,
  pax: number,
  departureDate: string,
  returnDate: string,
  resultCount: number,
  isInitialSearch?: boolean,
): void => {
  sendEventWithTimeAndConnection(
    'load-search-results',
    { pax },
    {
      measurePerformance: 'page',
    },
    connection,
    pax,
    departureDate,
    returnDate,
    resultCount,
    isInitialSearch,
  )
}

const checkTimetable = (): void => {
  sendEventWithTime('check-timetable')
}

const clickDownloadTicket = (): void => {
  sendEvent('click-download-ticket')
}

const addTicketToGoogleWallet = (): void => {
  sendEvent('add-to-wallet')
}

export default {
  viewPage,
  clickTrip,
  loadSearchResults,
  clickTripExtended,
  viewLandingCityPage,
  checkTimetable,
  clickDownloadTicket,
  addTicketToGoogleWallet,
}
